import React, { useState } from "react";

const Formsiswa = (props) => {
	const [namasiswa, setNamasiswa] = useState("");
	const [sekolahsiswa, setSekolahsiswa] = useState(null);
	const [pesanerror, setPesanerror] = useState("");

	const [token, setToken] = useState("");

	const kuisLogin = (e) => {
		e.preventDefault();
		const tokenfix = "pilkomkuis2";

		if (namasiswa === "") {
			setPesanerror("Isi data dengan lengkap !");
		} else if (sekolahsiswa === null) {
			setPesanerror("Isi data dengan lengkap !");
		} else {
			if (token === tokenfix) {
				const user = {
					nama: namasiswa,
					sekolah: sekolahsiswa,
				};
				localStorage.setItem("siswa", JSON.stringify(user));
				props.palakao(user);
			} else {
				setPesanerror("Token Salah!");
			}
		}
	};
	return (
		<div className="container-fluid mt-5">
			<div className="h5 text-center" style={{ color: "#40bf80" }}>
				Data Siswa
			</div>
			<div style={{ display: "flex", justifyContent: "center" }}>
				<hr style={{ width: "80%", height: "4px", color: "green" }}></hr>
			</div>
			<div className="d-flex justify-content-center">
				{pesanerror ? (
					<div className="alert alert-danger ">{pesanerror}</div>
				) : (
					""
				)}
			</div>
			<div className="d-flex justify-content-center mt-2">
				<form onSubmit={kuisLogin}>
					<div className="mt-3">
						<input
							value={namasiswa}
							onChange={(e) => setNamasiswa(e.target.value)}
							type="text"
							className="form-control shadow bg-body rounded"
							placeholder="Nama Lengkap"
						/>
					</div>
					<div className="mt-3">
						<select
							onChange={(e) => setSekolahsiswa(e.target.value)}
							className="form-select shadow bg-body rounded"
						>
							<option value={null} selected>
								Pilih Sekolah
							</option>
							<option value={sekolahsiswa}>IPA 1</option>
							<option value={sekolahsiswa}>IPA 2</option>
							<option value={sekolahsiswa}>IPA 3</option>
						</select>
					</div>
					<div className="mt-3">
						<input
							className="form-control shadow bg-body rounded"
							type="text"
							placeholder="Token"
							onChange={(e) => setToken(e.target.value)}
							value={token}
						/>
					</div>
					<div className="text-center mt-2">
						<input
							type="submit"
							className="btn btn-success"
							value="Mulai Kuis"
						/>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Formsiswa;
